const MARKDOWN_REFERENCE_TAG_REGEX = /!item\[([^\]\r\n]+)\]\(([^)\r\n]+)\)(?:\(([^)\r\n]*)\))?|!bom\[([^\]\r\n]+)\](?:\(([^)\r\n]*)\))?|!guide\[([^\]\r\n]+)\](?:\(([^)\r\n]*)\))?/gi;

export function getMarkdownReferencePreviewLabel(rawTarget) {
  const target = (rawTarget || '').toString().trim();
  if (!target) return 'BOM';
  return (target.split(',')[0] || target).trim() || 'BOM';
}

export function sanitizeMarkdownPreviewText(rawValue) {
  const source = typeof rawValue === 'string' ? rawValue : '';
  if (!source.trim()) return '';

  let text = source.replace(/\r\n/g, '\n');

  text = text.replace(
    MARKDOWN_REFERENCE_TAG_REGEX,
    (
      fullMatch,
      itemBomSlugRaw,
      itemIdentifierRaw,
      itemOptionalNameRaw,
      bomSlugRaw,
      bomOptionalNameRaw,
      guideSlugRaw,
      guideOptionalNameRaw
    ) => {
      const itemBomSlug = (itemBomSlugRaw || '').toString().trim();
      if (itemBomSlug) {
        const identifier = (itemIdentifierRaw || '').toString().trim();
        const optionalName = (itemOptionalNameRaw || '').toString().trim();
        return optionalName || identifier || 'item';
      }

      const bomSlug = (bomSlugRaw || '').toString().trim();
      if (bomSlug) {
        const optionalName = (bomOptionalNameRaw || '').toString().trim();
        return optionalName || getMarkdownReferencePreviewLabel(bomSlug);
      }

      const guideSlug = (guideSlugRaw || '').toString().trim();
      if (guideSlug) {
        const optionalName = (guideOptionalNameRaw || '').toString().trim();
        return optionalName || guideSlug || 'guide';
      }

      return fullMatch;
    }
  );

  text = text.replace(/!\[([^\]\r\n]*)\]\(([^)\r\n]+)\)/g, '$1');
  text = text.replace(/\[([^\]\r\n]+)\]\(([^)\r\n]+)\)/g, '$1');
  text = text.replace(/<((?:https?:\/\/|mailto:)[^>\s]+)>/gi, '$1');
  text = text.replace(/<[^>\n]+>/g, ' ');

  text = text.replace(/^>\s?/gm, '');
  text = text.replace(/^(\s*)([-*+]|(\d+)\.)\s+/gm, '$1');
  text = text.replace(/(^|\s)#{1,6}\s+/g, '$1');

  text = text.replace(/```([a-z0-9_-]+)?\n?/gi, '');
  text = text.replace(/`([^`]+)`/g, '$1');
  text = text.replace(/(\*\*|__)(.*?)\1/g, '$2');
  text = text.replace(/(\*|_)(.*?)\1/g, '$2');
  text = text.replace(/~~(.*?)~~/g, '$1');
  text = text.replace(/\\([\\`*_{}[\]()#+.!|>~-])/g, '$1');

  return text.replace(/\s+/g, ' ').trim();
}
